import React from 'react';
import { Link } from 'react-router-dom';

const RequestTimeoutPage = () => {
  return (
    <div className="error-page">
      <h1>408 Request Timeout</h1>
      <p>The request took too long to process. Please try again later.</p>
      <Link to="/">Go back to Home</Link>
    </div>
  );
};

export default RequestTimeoutPage;
